const Recipes = () => (
  <main>
    <h1>Recipes</h1>
    <p>Try your hand at some of Curty’s favorite cookie recipes straight from the kitchen!</p>
    <ul>
      <li>21 cups of flour</li>
      <li>11 eggs</li>
      <li>44 tablespoons of sugar</li>
      <li>43 sticks of butter</li>
      <li>34 ounces of chocolate chips</li>
    </ul>
  </main>
);

export default Recipes;